import styled from '@emotion/styled';

export const BannerContent = styled.div`
    width: 100%;
    background: #FFFFFF;
    padding: 32px;
    display: flex;
    flex-direction: column;
    
    @media (max-width: 768px) {
        padding: 24px;
    }
`;

export const BannerTitle = styled.h2`
    font-size: 1.8rem;
    font-weight: 500;
    color: #2ABAFF;
    margin: 0 0 20px 0;
    text-align: left;
    font-family: 'Proxima Nova W08 Reg', sans-serif;
    line-height: 1.3;
    
    @media (max-width: 768px) {
        font-size: 1.6rem;
    }
`;

export const MessageContainer = styled.div`
    max-height: 300px;
    overflow-y: auto;
    padding: 16px;
    background: #FAFAFA;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    margin-bottom: 24px;
    
    /* Custom scrollbar */
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #F5F5F5;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #CCCCCC;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #AAAAAA;
    }
`;

export const BannerMessage = styled.p`
    font-size: 1.3rem;
    line-height: 1.6;
    color: #333333;
    margin: 0 0 12px 0;
    text-align: left;
    font-family: 'Proxima Nova W08 Reg', sans-serif;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    @media (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5;
    }
`;

export const BulletList = styled.ul`
    margin: 8px 0 12px 20px;
    padding: 0;
    list-style-type: disc;
`;

export const BulletItem = styled.li`
    font-size: 1.3rem;
    line-height: 1.6;
    color: #333333;
    margin-bottom: 6px;
    font-family: 'Proxima Nova W08 Reg', sans-serif;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    @media (max-width: 768px) {
        font-size: 1.2rem;
        line-height: 1.5;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;

    button {
        min-width: 120px;
        height: 42px;
        background-color: #2ABAFF;
        color: #FFFFFF;
        text-transform: none;
        font-weight: 600;
        font-size: 1.4rem;

        &:hover, &:focus {
            background-color: #2ABAFF;
        }
    }
`;

